import React, { useEffect,  useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import FStatement from "./Componets/FStatement";
import GroupWise from "./Componets/GroupWise";
import WithOutGroup from "./Componets/WithOutGroup";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASFilter from "../../../../components/FilterBox/FASFilter/FASFilter";
import { BankList } from "../../../../Redux/Slice/Fas/Financial Statement/Fund And Flow/FundAndFlow";
import { AcGroupList } from "../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const FundAndFlow = () => {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { AcGroupListdata } = useSelector((state) => state.LedgerSlice);
  const { BankListdata } = useSelector((state) => state.FundFlowSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  const [activeTab, setActiveTab] = useState("F-STATEMENT");

  useEffect(() => {
    dispatch(BankList({}));
    dispatch(AcGroupList({ Firm, Year: YearId }));
  }, [dispatch, Firm, YearId]);

  const [search, setSearch] = useState({
    month: "",
    bank: "",
    accountGroup: "",
  });
  const [filters, setFilters] = useState({
    month: [],
    bank: [],
    accountGroup: [],
  });


  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.month,
    })) || [];
  const accountGroupList =
    AcGroupListdata?.data?.map((item) => ({
      label: item?.GroupMstName,
      value: item?.GroupMstID,
    })) || [];
  const banksList =
    BankListdata?.List?.map((item) => ({
      label: item?.BankName,
      value: item?.BankID,
    })) || [];
  const actionButtons = ["F-STATEMENT", "GROUPWISE", "WITHOUT GROUP"];

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const renderPage = () => {
    const commonProps = {
      month: filters.month,
      bank: filters.bank,
      accountGroup: filters.accountGroup,
    };

    switch (activeTab) {
      case "F-STATEMENT":
        return <FStatement {...commonProps} />;
      case "GROUPWISE":
        return <GroupWise {...commonProps} />;
      case "WITHOUT GROUP":
        return <WithOutGroup {...commonProps} />;
      default:
        return <FStatement {...commonProps} />;
    }
  };

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>{`
        .hover-scale-btn {
          transition: transform 0.2s ease-in-out;
        }
        .hover-scale-btn:hover {
          transform: scale(1.02);
        }
      `}</style>
      <div
        className="d-lg-none"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "12px",
        }}
      >
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS FILTER */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            {" "}
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "30px",
          }}
        >
          <div
            style={{
              position: "sticky",
              top: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <FASFilter
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            {activeTab === "F-STATEMENT" && (
              <>
                <FASFilter
                  title="Bank Name"
                  items={banksList}
                  search={search.bank}
                  setSearch={(val) => handleSearch("bank", val)}
                  selectedItems={filters.bank}
                  toggleItem={(item) => toggleItem("bank", item)}
                  selectAll={() => selectAll("bank", banksList)}
                />
              </>
            )}
            <FASFilter
              title="Account Group"
              items={accountGroupList}
              search={search.accountGroup}
              setSearch={(val) => handleSearch("accountGroup", val)}
              selectedItems={filters.accountGroup}
              toggleItem={(item) => toggleItem("accountGroup", item)}
              selectAll={() => selectAll("accountGroup", accountGroupList)}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="align-items-start">
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} md={12} className="d-none d-lg-block">
          <div
            style={{
              position: "sticky",
              top: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <FASFilter
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            {activeTab === "F-STATEMENT" && (
              <>
                <FASFilter
                  title="Bank Name"
                  items={banksList}
                  search={search.bank}
                  setSearch={(val) => handleSearch("bank", val)}
                  selectedItems={filters.bank}
                  toggleItem={(item) => toggleItem("bank", item)}
                  selectAll={() => selectAll("bank", banksList)}
                />
              </>
            )}
            <FASFilter
              title="Account Group"
              items={accountGroupList}
              search={search.accountGroup}
              setSearch={(val) => handleSearch("accountGroup", val)}
              selectedItems={filters.accountGroup}
              toggleItem={(item) => toggleItem("accountGroup", item)}
              selectAll={() => selectAll("accountGroup", accountGroupList)}
            />
          </div>
        </Col>

        {/* RIGHT SIDE CONTENT */}
        <Col xl={9} lg={8} md={12}>
          <Row className="g-3 mb-3">
            {actionButtons.map((btn, index) => {
              const isActive = activeTab === btn;

              return (
                <Col xs={12} md={4} key={index}>
                  <button
                    onClick={() => setActiveTab(btn)}
                    className="hover-scale-btn"
                    style={{
                      width: "100%",
                      height: "58px",
                      backgroundColor: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,
                      border: `2px solid ${
                        isActive
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour4
                            : iscolourDark?.Colour10
                      }`,
                      borderRadius: "14px",
                      fontWeight: "bold",
                      color: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour9,
                      fontSize: "14px",
                    }}
                  >
                    {btn}
                  </button>
                </Col>
              );
            })}
          </Row>

          {renderPage()}
        </Col>
      </Row>
    </div>
  );
};
